var _defs, _path, _path2, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivingCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e95045;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #fae725;\n      }\n\n      .cls-4 {\n        fill: #39ade2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128,38c-49.7,0-90,40.29-90,90s40.3,90,90,90,90-40.29,90-90c0-49.71-40.29-90-90-90Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.65,117.57l-48.47-45.01c-2.2-2.52-6.03-2.78-8.56-.58-.26,.23-.5,.48-.72,.75l-47.5,44.84h0v66.11c0,3.06,2.48,5.54,5.54,5.54h94.17c3.06,0,5.54-2.48,5.54-5.54V117.57h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 117.95,
    y: 108.9,
    width: 22.16,
    height: 22.16,
    rx: 5.54,
    ry: 5.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.96,128.15c-1.02,0-2.01-.37-2.77-1.05l-58.16-52.12-58.16,52.1c-1.7,1.54-4.33,1.4-5.87-.3,0,0,0,0,0,0-1.52-1.7-1.38-4.31,.31-5.83,0,0,.01-.01,.02-.02l58.88-52.76c2.74-2.45,6.89-2.45,9.64,0l58.88,52.76c1.71,1.5,1.88,4.11,.38,5.82-.79,.91-1.95,1.42-3.15,1.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.95,155.98h22.16c3.06,0,5.54,2.48,5.54,5.54v27.7h-33.24v-27.7c0-3.06,2.48-5.54,5.54-5.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingCondition);
export default __webpack_public_path__ + "static/media/living-condition.f5c305655f525a59c7fc0db07364a943.svg";
export { ForwardRef as ReactComponent };